module.exports = __webpack_public_path__ + "img/256x256_diamond_warp_gate.67b1158b.svg";